export function changeLoading(loading) {
	return {
		type: "@auth/CHANGE_LOADING",
		payload: {
			loading,
		},
	};
}

export function generateQrCodeRequest() {
	return {
		type: "@qrCode/GENERATE_QR_CODE_REQUEST",
		payload: {},
	};
}

export function generateQrCodeSuccess(auth_token) {
	return {
		type: "@qrCode/GENERATE_QR_CODE_SUCCESS",
		payload: { auth_token },
	};
}

export function verifyProcessRequest(auth_token) {
	return {
		type: "@qrCode/VERIFY_PROCESS_REQUEST",
		payload: { auth_token },
	};
}

export function proccessQrCodeLoginRequest(access_token) {
	return {
		type: "@qrCode/PROCCESS_QR_CODE_LOGIN_REQUEST",
		payload: { access_token },
	};
}

export function doTokenLoginRequest(token) {
	return {
		type: "@qrCode/DO_TOKEN_LOGIN_REQUEST",
		payload: { token },
	};
}

export function authorizeAuthTokenRequest(auth_token) {
	return {
		type: "@qrCode/AUTHORIZE_AUTH_TOKEN_REQUEST",
		payload: { auth_token },
	};
}

export function doTokenLoginRequestExternalToken(token) {
	return {
		type: "@qrCode/DO_TOKEN_LOGIN_REQUEST_EXTERNAL_TOKEN",
		payload: { token },
	};
}
